module.exports = __webpack_public_path__ + "media/src/images/favicons/mstile-310x310-1cdb073c39e705078840d78e253cc6e2.png";